import React from 'react'

export default function addZoomedDragElement<T extends HTMLElement>(e: React.DragEvent<T>, scale: number, element: T) {
  // cone the dragged element
  const clone: T = ((element ?? e.currentTarget)).cloneNode(true) as T

  clone.style.position = 'relative'

  // wrap it in a container with padding to allow for shadows, outlines, etc.
  const wrapper = document.createElement('div')
  wrapper.appendChild(clone)

  // sdd the temporary element to the document
  document.body.appendChild(wrapper)

  // scale the element to the specified size
  const baseSize = element.clientWidth
  wrapper.style.padding =`${baseSize * scale / 4}px`
  clone.style.width = `${baseSize * scale}px`
  clone.style.height = `${baseSize * scale}px`

  const fullSize = (baseSize * scale / 4 * 2) + baseSize * scale

  wrapper.style.position = 'fixed'
  wrapper.style.left = '0px'
  wrapper.style.top = '0px'
  // hide the temporary element by putting it behind the app
  wrapper.style.zIndex = '-100000'

  // set the cursor to be bottom-centre of the element
  const dragImageOffset = fullSize / 2

  e.dataTransfer.setDragImage(wrapper, dragImageOffset, dragImageOffset * 1.5)

  // clean up the temporary element after the drag has started
  setTimeout(() => {
    document.body.removeChild(wrapper)
  }, 10)
}